module.exports = __webpack_public_path__ + "img/Loading-Blue.ea67c1c4.svg";